import { isDevelopment } from 'src/tpbp-core/utils/common.utils'
import { FEATURE_IDS } from 'src/tpbp-core/feature-flag/featureFlags.const'
import { hasFeature } from 'src/tpbp-core/feature-flag/featureFlags.utils'

export const logger = {
  log: (...arguments_: unknown[]): void => {
    const canUseConsoleLog =
      (isDevelopment || hasFeature(FEATURE_IDS.debug)) &&
      typeof window !== 'undefined'
    if (canUseConsoleLog) {
      console.log(...arguments_) // eslint-disable-line no-console
    }
  },
  warn: (...arguments_: unknown[]): void => {
    const canUseConsoleWarn =
      (isDevelopment || hasFeature(FEATURE_IDS.debug)) &&
      typeof window !== 'undefined'
    if (canUseConsoleWarn) {
      console.warn(...arguments_) // eslint-disable-line no-console
    }
  },
  error: (...arguments_: unknown[]): void => {
    const canUseConsoleError =
      (isDevelopment || hasFeature(FEATURE_IDS.debug)) &&
      typeof window !== 'undefined'
    if (canUseConsoleError) {
      console.error(...arguments_) // eslint-disable-line no-console
    }
  },
}
